module.exports = "/public/images/128a1c453a13110598a2c536b7d15975.png";